import {html} from 'lit-html';

const metaIntroTemplate = () => html`
  <div class="event-detail">
    <div class="event-description">
      <h1>COVID-19 Evidence-to-Policy Tracker</h1>
      <p>This visualisation tracks how policy interventions are being made by various national and sub-national governments across the world. Explore the advice, evidence and other justifications that underpinned government decision-making at different points in the timeline of the crisis.</p>
      <p>Select a country at the top-left and policy items and interventions will be loaded into the display. You can <b>click-drag on the visualisation</b> to move left and right in time and up and down to see different countries. If you don't see any items, try using click-drag to check if there are any later in time.</p>
      <p>The ⬤ mark denotes policy decisions and actions where an evidence-based justification was provided.</p>
      <p>Please note that we are still collecting data and we will be adding further updates over time, as well as improving categorisation. We are also working on functionality to help separate interventions in different states for Federal jurisdictions.</p>
      <div class="contribution">
        <h2>Updates and Corrections</h2>
        <p>Please contact us if you spot an error, missing information or want to contribute. Email <a href="mailto:covid@ingsa.org">covid@ingsa.org</a> or view our <a href="#">contribution guidelines</a></p>
      </div>
    </div>
  </div>
`;

export {
  metaIntroTemplate
}
